import { REDUCE_RISK_CHANGED } from '../../constants/actions/policy';

export function reduceRiskChanged(payload) {
    return {
        type: REDUCE_RISK_CHANGED,
        payload,
    };
}
